// extracted by mini-css-extract-plugin
module.exports = {"innerWrapper":"OO","tooltipWrapper":"PO","icon":"QO","tooltip":"RO","content":"SO"};